/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fields: NonNullable<unknown> }} Directory_Submit_Autofill_UncertainInputs */

const en_directory_submit_autofill_uncertain = /** @type {(inputs: Directory_Submit_Autofill_UncertainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Review these fields: ${i?.fields}.`)
};

const zh_directory_submit_autofill_uncertain = /** @type {(inputs: Directory_Submit_Autofill_UncertainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`请检查这些字段：${i?.fields}。`)
};

/**
* | output |
* | --- |
* | "Review these fields: {fields}." |
*
* @param {Directory_Submit_Autofill_UncertainInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_autofill_uncertain = /** @type {((inputs: Directory_Submit_Autofill_UncertainInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Autofill_UncertainInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_autofill_uncertain(inputs)
	return zh_directory_submit_autofill_uncertain(inputs)
});
export { directory_submit_autofill_uncertain as "directory.submit.autofill_uncertain" }